var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-page-shell',{attrs:{"title":_vm.$t('frontend_groovemail_admin_blocklists')}},[_c('template',{slot:"tabs"},[_c('gd-tabs',{attrs:{"tabs":_vm.tabs,"currentTab":_vm.currentTab},on:{"onClick":_vm.handleTabChange}})],1),_c(_vm.currentTab,{tag:"component"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }